<template>
  <b-dropdown
    ref="dropdown"
    size="sm"
    variant="link"
    toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none position-relative"
    :class="{
      'notification-dropdown--mobile': mobileInline,
      'notification-dropdown--open': mobileInline && isOpen
    }"
    no-caret
    right
    no-flip
    @show="handleShow"
    @hide="handleHide"
  >
    <template v-slot:button-content>
      <i class="flaticon2-bell-4" />
      <span v-if="unreadCount" class="notification-badge">{{ unreadCount }}</span>
    </template>

    <b-dropdown-text tag="div" class="notification-dropdown__panel">
      <div class="d-flex align-items-center justify-content-between px-5 py-4 border-bottom">
        <span class="font-weight-bolder">Известия</span>
        <button
          v-if="unreadCount"
          type="button"
          class="btn btn-link btn-sm p-0"
          @click="markAllRead"
        >
          Маркирай всички като прочетени
        </button>
      </div>

      <div v-if="notifications.length" class="notification-list">
        <button
          v-for="notification in notifications"
          :key="notification.id"
          type="button"
          class="notification-item w-100 text-left px-5 py-4 border-0"
          :class="{ 'notification-item--unread': !notification.readAt }"
          @click="openNotification(notification)"
        >
          <div class="font-weight-bold">{{ notification.data.message }}</div>
          <div v-if="notification.data.machine" class="text-muted mt-1">
            {{ notification.data.machine }}
          </div>
          <div class="text-muted font-size-sm mt-1">{{ notification.createdAt }}</div>
        </button>
      </div>
      <div v-else class="text-center text-muted py-8">Няма известия.</div>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "KTDropdownNotification",
  props: {
    mobileInline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notifications: [],
      unreadCount: 0,
      refreshTimer: null,
      isOpen: false
    };
  },
  mounted() {
    this.refresh();
    this.refreshTimer = window.setInterval(this.refresh, 60000);
  },
  beforeDestroy() {
    window.clearInterval(this.refreshTimer);
  },
  methods: {
    handleShow() {
      this.isOpen = true;
      this.refresh();
    },
    handleHide() {
      this.isOpen = false;
    },
    refresh() {
      return Promise.all([
        ApiService.get("notifications"),
        ApiService.get("notifications/unread-count")
      ])
        .then(([notificationsResponse, countResponse]) => {
          this.notifications = notificationsResponse.data.data.items;
          this.unreadCount = countResponse.data.data.count;
        })
        .catch(() => {});
    },
    markAllRead() {
      ApiService.put("notifications/read-all")
        .then(() => this.refresh())
        .catch(() => {});
    },
    openNotification(notification) {
      this.$refs.dropdown.hide();
      this.$router.push(notification.data.route);

      if (!notification.readAt) {
        ApiService.put(`notifications/${notification.id}/read`)
          .then(() => this.refresh())
          .catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-badge {
  position: absolute;
  top: 2px;
  right: 0;
  min-width: 17px;
  padding: 1px 4px;
  border-radius: 10px;
  background: #f64e60;
  color: #fff;
  font-size: 10px;
  line-height: 15px;
}

.notification-dropdown__panel {
  width: 360px;
}

.notification-list {
  max-height: 40vh;
  overflow-y: auto;
}

.notification-item {
  background: #fff;
}

.notification-item:hover,
.notification-item--unread {
  background: #f3f6f9;
}

@media (max-width: 991.98px) {
  .notification-dropdown--mobile ::v-deep .dropdown-toggle {
    align-items: center;
    display: inline-flex !important;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 0 !important;
    padding: 0 !important;
    border-radius: 0.42rem;
  }

  .notification-dropdown--mobile:not(.notification-dropdown--open)
    ::v-deep .dropdown-toggle {
    background: transparent !important;
    color: #fff !important;
  }

  .notification-dropdown--mobile.notification-dropdown--open
    ::v-deep .dropdown-toggle {
    background: #fff !important;
    color: #3699ff !important;
  }

  .notification-dropdown--mobile ::v-deep .dropdown-menu {
    position: fixed !important;
    top: 64px !important;
    right: 1rem !important;
    left: 1rem !important;
    width: auto !important;
    max-width: calc(100vw - 2rem);
    box-sizing: border-box;
    margin: 0 !important;
    transform: none !important;
    border: 0;
    border-radius: 0.42rem;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.16);
    overflow: hidden;
  }

  .notification-dropdown--mobile ::v-deep .notification-dropdown__panel {
    width: auto;
  }
}
</style>
